/**
 * Back Button Component
 * Single responsibility: render back control and navigate on click.
 * Dependency Inversion: receives navigation target from parent (or default route).
 */

import React, { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import ROUTES from '../../constants/routes';

const DEFAULT_BACK_LABEL = 'Back';

/**
 * @param {{ to?: string, label?: string }} props
 */
export const BackButton = ({
  to = ROUTES.ORGANIZATION_CONFIGURATION,
  label = DEFAULT_BACK_LABEL,
}) => {
  const navigate = useNavigate();
  const handleClick = useCallback(() => navigate(to), [navigate, to]);

  return (
    <button
      onClick={handleClick}
      className="content-stretch flex gap-[12px] items-center cursor-pointer hover:opacity-80 transition-opacity"
      type="button"
      aria-label={label}
    >
      <div className="relative shrink-0 size-[24px]" data-name="arrow_back">
        <svg className="block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 24 24">
          <g id="arrow_back">
            <mask
              height="24"
              id="mask0_5_196"
              maskUnits="userSpaceOnUse"
              style={{ maskType: 'alpha' }}
              width="24"
              x="0"
              y="0"
            >
              <rect fill="var(--fill-0, #D9D9D9)" height="24" id="Bounding box" width="24" />
            </mask>
            <g mask="url(#mask0_5_196)">
              {/* TODO: Add SVG path when svgPaths is available */}
              {/* <path d={svgPaths.p38ded900} fill="var(--fill-0, #1C1B1F)" id="arrow_back_2" /> */}
              <path
                d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"
                fill="var(--fill-0, #1C1B1F)"
                id="arrow_back_2"
              />
            </g>
          </g>
        </svg>
      </div>

      <p
        className="font-['Roboto:Regular',sans-serif] font-normal leading-[normal] relative shrink-0 text-[20px] text-black text-nowrap"
        style={{ fontVariationSettings: "'wdth' 100" }}
      >
        {label}
      </p>
    </button>
  );
};
